/**
 * ============================================================
 * HUGIFY — Sticky Cart Bar
 * assets/sticky-cart-bar.js
 * ============================================================
 */

(function () {
  'use strict';

  var bar, trigger, panel, addonsContainer, addBtn, spacer;
  var isOpen    = false;
  var isVisible = false;

  document.addEventListener('DOMContentLoaded', function () {
    bar             = document.getElementById('sticky-cart-bar');
    trigger         = bar && bar.querySelector('.sticky-cart-bar__trigger');
    panel           = bar && bar.querySelector('.sticky-cart-bar__panel');
    addonsContainer = bar && bar.querySelector('.sticky-cart-bar__addons');
    addBtn          = bar && bar.getElementById
                        ? document.getElementById('sticky-cart-btn')
                        : bar && bar.querySelector('.sticky-cart-bar__btn');
    spacer          = document.getElementById('sticky-cart-spacer');

    if (!bar) return;

    watchMainButton();
    trigger && trigger.addEventListener('click', togglePanel);
    copyAddons();
    addBtn && addBtn.addEventListener('click', handleAddToCart);
    bar.addEventListener('change', updatePrice);
    document.addEventListener('addon:changed', onMainAddonChanged);
  });

  function watchMainButton() {
    var mainBtn = document.querySelector(
      'form[action="/cart/add"] [name="add"], ' +
      '.product-form__submit, ' +
      '[data-add-to-cart]'
    );

    if (!mainBtn) { showBar(); return; }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.isIntersecting ? hideBar() : showBar();
        });
      }, { threshold: 0 });
      observer.observe(mainBtn);
    } else {
      window.addEventListener('scroll', function () {
        var rect = mainBtn.getBoundingClientRect();
        var inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
        inView ? hideBar() : showBar();
      }, { passive: true });
    }
  }

  function showBar() {
    if (isVisible) return;
    isVisible = true;
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
    updateSpacer();
  }

  function hideBar() {
    if (!isVisible) return;
    isVisible = false;
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    if (isOpen) closePanel();
    updateSpacer();
  }

  function updateSpacer() {
    if (!spacer) return;
    spacer.style.height = isVisible ? bar.offsetHeight + 'px' : '0';
  }

  function togglePanel() { isOpen ? closePanel() : openPanel(); }

  function openPanel() {
    isOpen = true;
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    updatePrice();
    updateSpacer();
  }

  function closePanel() {
    isOpen = false;
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    updateSpacer();
  }

  function copyAddons() {
    var mainAddonsList = document.querySelector(
      '.product-addons:not(#sticky-cart-bar *) .product-addons__list'
    );
    if (!mainAddonsList || !addonsContainer) return;

    var tries = 0;
    var poll  = setInterval(function () {
      tries++;
      var items = mainAddonsList.querySelectorAll('.product-addon-item');
      if (items.length > 0) {
        clearInterval(poll);
        items.forEach(function (item) {
          var clone = item.cloneNode(true);
          var cb = clone.querySelector('.product-addon-item__checkbox');
          if (cb) {
            var newId = 'sticky-' + (cb.id || ('addon-' + Math.random().toString(36).slice(2)));
            cb.id = newId;
            clone.setAttribute('for', newId);
          }
          clone.classList.remove('is-selected');
          addonsContainer.appendChild(clone);
        });
      }
      if (tries > 40) clearInterval(poll);
    }, 100);
  }

  function onMainAddonChanged(e) {
    var detail = e.detail || {};
    var stickyCheckboxes = addonsContainer
      ? addonsContainer.querySelectorAll('.product-addon-item__checkbox')
      : [];
    stickyCheckboxes.forEach(function (cb) {
      var addonId = cb.getAttribute('data-addon-id');
      if (addonId === detail.addonId) {
        cb.checked = detail.checked;
        var item = cb.closest('.product-addon-item');
        if (item) item.classList.toggle('is-selected', detail.checked);
      }
    });
    updatePrice();
  }

  function updatePrice() {
    var priceEl   = bar.querySelector('.sticky-cart-bar__price');
    var totalEl   = bar.querySelector('[data-total-label]');
    var baseCents = parseInt(bar.getAttribute('data-variant-id') ? getVariantPrice() : 0) || 0;
    var extraCents = 0;

    if (addonsContainer) {
      addonsContainer.querySelectorAll('.product-addon-item__checkbox:checked').forEach(function (cb) {
        var item  = cb.closest('.product-addon-item');
        var addon = item ? safeParseJSON(item.getAttribute('data-addon')) : null;
        if (addon && addon.price_cents) extraCents += parseInt(addon.price_cents) || 0;
      });
    }

    var totalCents = baseCents + extraCents;
    if (priceEl) priceEl.textContent = formatMoney(totalCents);
    if (totalEl) totalEl.textContent = extraCents > 0 ? '(' + formatMoney(totalCents) + ')' : '';
  }

  function getVariantPrice() {
    var priceEl = bar.querySelector('[data-base-price]');
    return priceEl ? parseInt(priceEl.getAttribute('data-base-price')) || 0 : 0;
  }

  function handleAddToCart() {
    var variantId = bar.getAttribute('data-variant-id');
    if (!variantId) return;

    addBtn.classList.add('is-loading');
    var properties = {};
    if (addonsContainer) {
      addonsContainer.querySelectorAll('.product-addon-item__checkbox:checked').forEach(function (cb) {
        var item  = cb.closest('.product-addon-item');
        var addon = item ? safeParseJSON(item.getAttribute('data-addon')) : null;
        if (addon && addon.type === 'property') properties[addon.title] = 'Ja';
      });
    }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Fout bij toevoegen');
        return res.json();
      })
      .then(function () { return addPaidAddons(); })
      .then(function () {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');
        var label = addBtn.querySelector('.sticky-cart-bar__btn-label');
        if (label) label.textContent = 'Toegevoegd ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          addBtn.classList.remove('is-added');
          if (label) label.textContent = 'Toevoegen aan winkelwagen';
        }, 2200);
      })
      .catch(function (err) {
        console.error('[sticky-cart] Toevoegen mislukt:', err);
        addBtn.classList.remove('is-loading');
        alert('Kon product niet toevoegen. Probeer het opnieuw.');
      });
  }

  function addPaidAddons() {
    var promises = [];
    if (addonsContainer) {
      addonsContainer.querySelectorAll('.product-addon-item__checkbox:checked').forEach(function (cb) {
        var item  = cb.closest('.product-addon-item');
        var addon = item ? safeParseJSON(item.getAttribute('data-addon')) : null;
        if (addon && addon.type === 'product' && addon.variant_id
            && addon.variant_id !== 'VERVANG_MET_JOUW_VARIANT_ID') {
          promises.push(fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ id: addon.variant_id, quantity: 1 })
          }));
        }
      });
    }
    return Promise.all(promises);
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function safeParseJSON(str) {
    try { return JSON.parse(str); } catch (e) { return null; }
  }

})();
